<template>
  <v-row align="center" justify="center">
    <v-col cols="12" class="d-flex justify-center">
      <v-card style="width: 800px" shaped>
        <v-card-title>
          <v-icon large left color="primary">mdi-playlist-remove</v-icon>
          <span class="title font-weight-light">Недостающие позиции</span>
        </v-card-title>
        <v-col>
          <v-expansion-panels flat>
            <v-expansion-panel>
              <v-expansion-panel-header>Немного об отчёте</v-expansion-panel-header>
              <v-expansion-panel-content>
                <p class="text-justify">
                  Отчёт показывает товары, которые есть в прайсах выбранных конкурентов вашего города
                  и отсутствуют в прайсе вашего филиала, и цены конкурентов на них.
                  Учитываются прайсы не старше {{ options.priceMaxAgeDays }} дней.
                </p>
                <p class="font-weight-medium mb-1">Шаги построения отчёта:</p>
                <ol class="mb-0">
                  <li>Выберите регион.</li>
                  <li>Выберите свой филиал в этом регионе.</li>
                  <li>Выберите от 1 до {{ options.maxCompetitorCount }} конкурентов региона.</li>
                  <li>Нажмите «Сформировать отчёт» — файл Excel скачается автоматически.</li>
                </ol>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
        <v-form ref="form">
          <v-col class="d-flex">
            <v-autocomplete
              class="mx-2"
              label="Регион"
              item-text="name"
              item-value="id"
              :items="options.cities"
              :loading="loading.options"
              v-model="cityId"
              :rules="cityRules"
              @change="OnCityChange()"
            ></v-autocomplete>
          </v-col>
          <v-col class="d-flex">
            <v-autocomplete
              class="mx-2"
              :label="ownFilialLabel"
              item-text="name"
              item-value="id"
              :items="ownFilials"
              :loading="loading.options"
              :disabled="!cityId"
              v-model="ownFilialId"
              :rules="ownFilialRules"
            ></v-autocomplete>
          </v-col>
          <v-col class="d-flex">
            <v-autocomplete
              class="mx-2"
              label="Конкуренты"
              item-text="name"
              item-value="id"
              :items="competitorFilials"
              :loading="loading.options"
              :disabled="!cityId"
              v-model="competitorFilialIds"
              :rules="competitorRules"
              multiple
              chips
              small-chips
              deletable-chips
              clearable
              persistent-hint
              :hint="competitorsHint"
            ></v-autocomplete>
          </v-col>
          <v-col class="d-flex">
            <v-btn
              :loading="loading.download"
              @click="DownloadReport()"
              block
              color="primary"
            >
              Сформировать отчёт
              <template v-slot:loader>
                <span>Отчёт формируется...</span>
              </template>
            </v-btn>
          </v-col>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    cityId: null,
    ownFilialId: null,
    competitorFilialIds: [],
    options: {
      distributorName: null,
      cities: [],
      ownFilials: [],
      competitorFilials: [],
      maxCompetitorCount: 10,
      priceMaxAgeDays: 7,
    },
    loading: {
      options: true,
      download: false,
    },
  }),
  computed: {
    ownFilialLabel() {
      return this.options.distributorName
        ? `Филиал: ${this.options.distributorName}`
        : "Филиал";
    },
    // Оба списка приходят по всем городам, фронт фильтрует по выбранному региону
    ownFilials() {
      return this.options.ownFilials.filter((f) => f.cityId === this.cityId);
    },
    competitorFilials() {
      return this.options.competitorFilials.filter((f) => f.cityId === this.cityId);
    },
    competitorsHint() {
      return `От 1 до ${this.options.maxCompetitorCount} конкурентов`;
    },
    cityRules() {
      return [(value) => !!value || "Выберите регион"];
    },
    ownFilialRules() {
      return [(value) => !!value || "Выберите свой филиал"];
    },
    competitorRules() {
      return [
        (value) =>
          (Array.isArray(value) &&
            value.length >= 1 &&
            value.length <= this.options.maxCompetitorCount) ||
          `Выберите от 1 до ${this.options.maxCompetitorCount} конкурентов`,
      ];
    },
  },
  mounted() {
    this.GetFilterOptions();
  },
  methods: {
    async GetFilterOptions() {
      this.loading.options = true;
      try {
        this.options = await this.$store.dispatch("MISSING_GOODS_REPORT_FILTER_OPTIONS");
        if (this.options.cities.length === 1) {
          this.cityId = this.options.cities[0].id;
          this.OnCityChange();
        }
      } catch (error) {
        window.console.log(error);
      } finally {
        this.loading.options = false;
      }
    },
    // Смена региона сбрасывает филиал и конкурентов; единственный свой филиал выбирается сам
    OnCityChange() {
      this.competitorFilialIds = [];
      this.ownFilialId = this.ownFilials.length === 1 ? this.ownFilials[0].id : null;
    },
    DownloadReport() {
      if (!this.$refs.form.validate()) {
        return;
      }

      const request = {
        ownFilialId: this.ownFilialId,
        competitorFilialIds: this.competitorFilialIds,
      };

      this.loading.download = true;
      this.$store
        .dispatch("DOWNLOAD_MISSING_GOODS_REPORT", request)
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loading.download = false;
        });
    },
  },
};
</script>
